import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ReportService } from "../../services/report.service";
import { ARCHETYPES } from "../../types/archetypes";
import { CHARACTER_GROUP } from "../../const/character";
import { PaymentService } from "../../services/payment.service";
import { StripeService } from "ngx-stripe";
import { AmplitudeService } from "../../services/amplitude.service";
import { AuthService } from "../../services/auth.service";
import { getSurveyURL } from "../../utils/string";

@Component({
	selector: "app-one-time-offer",
	templateUrl: "./one-time-offer.component.html",
	styleUrls: ["./one-time-offer.component.scss"]
})
export class OneTimeOfferComponent implements OnInit {
	ARCHETYPES = ARCHETYPES;
	reportUUIDV4!: string;
	report: any;
	constructor(
		private activatedRoute: ActivatedRoute,
		public reportService: ReportService,
		public paymentService: PaymentService,
		public stripeService: StripeService,
		public router: Router,
		private amplitudeService: AmplitudeService,
		private authService: AuthService
	) {
		if (this.activatedRoute.snapshot.paramMap.keys.length) {
			if (this.activatedRoute.snapshot.paramMap.has("reportUUIDV4"))
				this.reportUUIDV4 = this.activatedRoute.snapshot.paramMap.get(
					"reportUUIDV4"
				) as unknown as string;
		}
	}
	get primary(): CHARACTER_GROUP {
		return this.report?.characterArchetypes?.[0]?.characterStrength;
	}
	get secondary(): CHARACTER_GROUP {
		return this.report?.characterArchetypes?.[1]?.characterStrength;
	}
	get tertiary(): CHARACTER_GROUP {
		return this.report?.characterArchetypes?.[2]?.characterStrength;
	}
	ngOnInit(): void {
		this.getReport();
	}
	getReport() {
		this.reportService.get(this.reportUUIDV4).subscribe((res: any) => {
			if (res.statusCode === 200) {
				if (res.authRequired) {
					if (res.isUserExist) {
						let url = this.router.url;
						this.authService.redirectToLogin({
							queryParams: { returnUrl: url, prefillEmailId: res.user.emailId },
							skipLocationChange: url ? true : false
						});
					} else {
						this.router.navigate(["user-sign-up"], { state: res });
					}
					return;
				}
				this.report = res.report;
				if (this.report.isPaid) {
					this.router.navigate([`/report/${this.reportUUIDV4}`]);
					return;
				}
				this.amplitudeService.track("View OTO page", {
					userId: this.authService.user.id,
					reportId: this.report.id
				});
				return;
			}
			return;
		});
	}
	bookNow(product: string) {
		this.amplitudeService.track("Book Session", {
			userId: this.authService.user.id,
			reportId: this.report.id
		});
		this.paymentService
			.createCheckout({
				reportId: this.report.id,
				reportUUIDV4: this.report.UUIDV4,
				product
			})
			.subscribe((session: any) => {
				this.stripeService
					.redirectToCheckout({ sessionId: session.id })
					.subscribe(res => {
						if (res.error) {
						} else {
							window.location.href = session.url; // Redirect to the checkout page
						}
					});
			});
	}
	openFreeReport() {
		const surveyURL = getSurveyURL();
		let path = `${surveyURL}/report/${this.report.UUIDV4}`;
		this.amplitudeService.track("View Free Report", {
			userId: this.authService.user.id,
			reportId: this.report.id
		});
		window.open(path);
	}
}
